module.exports = __webpack_public_path__ + "static/media/IMG_0549.94ad7d61.jpg";